
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { VariantListOptionModel } from './Entities.GormCrm.VariantListOption';
import { VariantListTypes } from 'enums/VariantListTypes';
import { Model, ModelProperty } from 'models/Model';


export class VariantListModel extends Model<VariantListModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'variantList.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'variantList.property.name' },
		{ name: 'deleted', type: 'Date', languageString: 'variantList.property.deleted', isHidden: true },
		{ name: 'variantListOptions', type: 'VariantListOptionModel[]', languageString: 'variantList.property.variantListOptions', isHidden: true, isArray: true, isObject: true, new: () => { return new VariantListOptionModel }, properties: () => { return VariantListOptionModel.classProperties } },
		{ name: 'type', type: 'VariantListTypes', languageString: 'variantList.property.type' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public deleted?: Date;
	public variantListOptions: VariantListOptionModel[];
	public type: VariantListTypes;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.deleted = undefined;
		this.variantListOptions = [];
		this.type = 0;
		
	}
	getProperties(){
		return VariantListModel.classProperties;
	}
}

